import { ComponentType } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { Roles } from 'src/enums/roles.enum';
import { useAuth } from '../../hooks';
import { Loader } from '../loader';
import { AppealsAdmin } from './appeals-admin';
import { AppealsEditForm } from './appeals-edit-form';
import { AppealsUser } from './appeals-user';

export const Appeals: ComponentType = () => {
  const { user } = useAuth();

  if (!user.data) return null;

  const applicationsView = () => {
    if (user?.isLoading) return <Loader minHeight="50vh" />;
    if (user?.data?.role === Roles.APPLICANT) return <AppealsUser />;
    return <AppealsAdmin />;
  };

  return (
    <Switch>
      <Route path={ROUTES.APPEALS.CREATE} component={AppealsEditForm} exact />
      <Route>{applicationsView()}</Route>
    </Switch>
  );
};
